export default __webpack_public_path__ + "static/datelabel-dropdown-dont-1-light-4d21466150fb70be2982486ae80e1cbde774e9f93d027a52651e76b6a26de707.png";